import Input from "../../../../Core/Fields/Floating/Input";


const OperationLeft = (TMA) => {

  return (
    <div className="row sidebarbox m-0 d-flex flex-column"
      style={{padding: "8px", borderRadius: "5px",minHeight:"300px", maxHeight: "480px",overflowY: "scroll"}}
    > 
   <div className="col-12 ">
        <Input id="orderNo" label="Transfer Material Against" readOnly  value={TMA.TMA} style={{ height: '30px' }} />
   </div>

  </div>
  )
}

export default OperationLeft